module.exports = __webpack_public_path__ + "img/124_thumbnail.14204d3a.jpg";